import '../types/index.mjs';
import { Language } from '../types/constants.mjs';
"use strict";
const isLanguage = language => {
  return !!language && Object.values(Language).includes(language);
};
export { isLanguage };
//# sourceMappingURL=language.mjs.map
